/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function SheetFromJSON(json) {
    return SheetFromJSONTyped(json, false);
}
export function SheetFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name'],
        rowTagIds: !exists(json, 'rowTagIds') ? undefined : json['rowTagIds'],
        columnTagIds: !exists(json, 'columnTagIds') ? undefined : json['columnTagIds'],
    };
}
export function SheetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        rowTagIds: value.rowTagIds,
        columnTagIds: value.columnTagIds,
    };
}
